import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotComics from './components/HotComics';
import CategoryShowcase from './components/CategoryShowcase';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotComics />
        <CategoryShowcase />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}